<template>
	<div class="relative">
		<div class="bg-yellow-200 fixed top-0 left-0 right-0 bottom-0 px-3 sm:px-16 md:px-24 z-negative">
			<div class="hidden lg:block absolute left-0 h-64 w-full bg-primary"></div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
    export default {
        name: "SecondaryBackground"
    }
</script>

<style scoped>

</style>
